import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SelectDropdown from "../../../components-react/SelectDropdown";
import { template_categories } from "../../../common-data/DropdowData";
import CloseSubmitBtn from "../../../common-components/custom-comps/CloseSubmitBtn";
import ReactQuillTextEditor from "../../../components-react/inputs/ReactQuillTextEditor";
import { validateTemplateForm } from "../../Validations";
import { commonPostPutApi } from "../../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../../components-react/ReactAlert";

const WPTemplateForm = ({
  isEdit,
  rowData,
  closeModal,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const forminitials = {
    templateName: isEdit ? rowData?.template_name : "",
    selectedTemplateCategory: isEdit
      ? template_categories.find(
          (category) => category.value === rowData?.category
        )
      : "",
    templateBody: isEdit ? rowData?.body : "",
    isActive: rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeTextInput = async (content, fieldName) => {
    setIsSubmit(false);

    setFormValues((prev) => ({ ...prev, [fieldName]: content }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmitForm = async (payload) => {
    try {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit
        ? "/wati/update_email_template"
        : "/wati/email_template";
      const token = userInfoData?.token || "";

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);

        callFunction();
        closeModal();
        toast.success(
          result?.payload?.message || "Template initiated successfully!"
        );
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error processing template:", error);
      toast.error("Failed to process template");
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateTemplateForm(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        template_name: formValues.templateName,
        category: formValues.selectedTemplateCategory?.value,
        body: formValues.templateBody,
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) {
        userData.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `${isEdit ? "Update" : "Add"} Template`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <form className="formContainer mb30">
      <div className="formInputsGrid twoGridSystem">
        <div className="formInputBox">
          <label htmlFor="templateName" className={`formInputLabel`}>
            template name <span className="required">*</span>
          </label>

          <input
            type="text"
            placeholder="Enter Template Name"
            className={`formInput ${
              formErrors?.templateName ? "formError" : ""
            }`}
            name="templateName"
            value={formValues.templateName}
            onChange={onChangeInput}
          />
        </div>

        <div className="formInputBox">
          <label
            htmlFor={`selectedTemplateCategory`}
            className={`formInputLabel `}>
            template category <span className="required">*</span>
          </label>

          <div
            className={`commonWrapper ${
              formErrors?.selectedTemplateCategory ? "formError" : ""
            }`}>
            <SelectDropdown
              options={template_categories}
              selectedOption={formValues.selectedTemplateCategory}
              setSelectedOption={(selectedValue) =>
                onChangeDropdown(selectedValue, "selectedTemplateCategory")
              }
              name="template category"
            />
          </div>
        </div>

        <div className="formInputBox span2">
          <label htmlFor="templateBody" className="formInputLabel">
            template body <span className="required">*</span>
          </label>

          <div className="commonWrapper textAreaCommonWrapper with-auto-height no-border">
            <ReactQuillTextEditor
              value={formValues.templateBody}
              setValue={(content) => onChangeTextInput(content, "templateBody")}
              isError={formErrors?.templateBody}
              loading={postPutLoading}
            />
          </div>
        </div>
      </div>

      <div className="formInputsGrid twoGridSystem">
        <div className="formInputBox checkbox-wrapper">
          <div className="flex-box">
            <label className="checkboxLabel">
              <input
                type="checkbox"
                name="isActive"
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
              Active
            </label>
          </div>
        </div>
      </div>

      <CloseSubmitBtn
        closeLabel="Cancel"
        submitLabel={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onSubmit={onSumitForm}
        isLoading={postPutLoading}
      />
    </form>
  );
};

export default WPTemplateForm;
